import PropTypes from "prop-types";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const MemberShipCard = ({ name, groupName, variant, communityId }) => {
  const navigate = useNavigate();

  // Define background and border colors for each variant
  const variants = {
    teal: { bg: "from-teal-50 to-teal-300", border: "border-teal-300" },
    green: { bg: "from-lime-50 to-lime-400", border: "border-lime-400" },
    orange: { bg: "from-orange-50 to-orange-300", border: "border-orange-300" },
    purple: {
      bg: "from-fuchsia-50 to-fuchsia-500",
      border: "border-fuchsia-500",
    },
    indigo: { bg: "from-indigo-50 to-indigo-500", border: "border-indigo-500" },
  };

  // Fallback to the teal variant if an invalid variant is passed
  const { bg, border } = variants[variant] || variants.teal;

  return (
    <div
      className={`bg-gradient-to-r mt-2 ${bg} ${border} border-l-4 p-4 rounded-lg shadow-md w-72`}
    >
      <div className="flex justify-between items-center">
        <h3 className="block text-sm text-gray-500 mb-2">Community Name</h3>
      </div>
      <p className="truncate text-gray-900 font-semibold text-lg">{name}</p>

      <div className="flex justify-between items-center mt-4">
        <div>
          <h4
            className={`block text-sm text-gray-500 mb-2 ${
              !groupName ? "hidden" : ""
            }`}
          >
            Group Name
          </h4>
          <p
            className={`text-gray-900 text-sm font-medium ${
              !groupName ? "hidden" : ""
            }`}
          >
            {groupName}
          </p>
        </div>
        <div>
          <Button onClick={() => navigate(`/view-communities/${communityId}`)}>
            View More
          </Button>
        </div>
      </div>
    </div>
  );
};

// Define PropTypes for the component
MemberShipCard.propTypes = {
  name: PropTypes.string.isRequired,
  groupName: PropTypes.string,
  variant: PropTypes.oneOf(["teal", "green", "orange", "purple", "indigo"]),
  communityId: PropTypes.string.isRequired, // Ensure this is passed
};

// Define default props for the component
MemberShipCard.defaultProps = {
  variant: "teal",
};

export default MemberShipCard;
